var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33334V4.66667M10 7.33334V8.66667M10 11.3333V12.6667M3.33333 3.33334C2.97971 3.33334 2.64057 3.47381 2.39052 3.72386C2.14048 3.97391 2 4.31305 2 4.66667V6.66667C2.35362 6.66667 2.69276 6.80715 2.94281 7.05719C3.19286 7.30724 3.33333 7.64638 3.33333 8C3.33333 8.35362 3.19286 8.69276 2.94281 8.94281C2.69276 9.19286 2.35362 9.33334 2 9.33334V11.3333C2 11.687 2.14048 12.0261 2.39052 12.2761C2.64057 12.5262 2.97971 12.6667 3.33333 12.6667H12.6667C13.0203 12.6667 13.3594 12.5262 13.6095 12.2761C13.8595 12.0261 14 11.687 14 11.3333V9.33334C13.6464 9.33334 13.3072 9.19286 13.0572 8.94281C12.8071 8.69276 12.6667 8.35362 12.6667 8C12.6667 7.64638 12.8071 7.30724 13.0572 7.05719C13.3072 6.80715 13.6464 6.66667 14 6.66667V4.66667C14 4.31305 13.8595 3.97391 13.6095 3.72386C13.3594 3.47381 13.0203 3.33334 12.6667 3.33334H3.33333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketOutline);
export default __webpack_public_path__ + "static/media/TicketOutline.15ef2d7d564af77c490968ea8551f212.svg";
export { ForwardRef as ReactComponent };